// extracted by mini-css-extract-plugin
export default {"category_list":"Category_category_list__KkCfb","blur":"Category_blur__k6mNw","category":"Category_category__mFOSQ"};